import { IAssetCategoryTypeResponse } from '@kcftech/prometheus-client';
import { Detail } from 'components/detail/detail';
import { DetailsContainer, DetailsSection, Section } from 'components/detail/styled';
import { AssetTypeNameInlineEditor } from 'pages/Settings/AssetType/table_cells/AssetTypeNameInlineEditor';
import { AssetTypeStatusInlineEditor } from 'pages/Settings/AssetType/table_cells/AssetTypeStatusInlineEditor';
import { DebugValue } from 'shared/debug/DebugValue';

export type AssetTypeDetailsContentProps = Readonly<{
    assetType: IAssetCategoryTypeResponse;
    onUpdate: () => void;
}>;

export function AssetTypeDetails({ assetType, onUpdate }: AssetTypeDetailsContentProps) {
    return (
        <DetailsContainer>
            <Section>
                <DebugValue value={assetType} description="Asset Type" />
                <AssetTypeNameInlineEditor assetType={assetType} onUpdate={onUpdate} />
            </Section>
            <div className="px-48 mt-20">
                <DetailsSection>
                    <Detail name="Code">{assetType.Code}</Detail>
                    <Detail name="Status">
                        <AssetTypeStatusInlineEditor
                            assetType={assetType}
                            onUpdate={onUpdate}
                        />
                    </Detail>
                </DetailsSection>
            </div>
        </DetailsContainer>
    );
}
